// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PicCenterOutlinedSvg from "@fishx/icons-svg/es/asn/PicCenterOutlined";
import FishxIcon from '../components/FishxIcon';

var PicCenterOutlined = function PicCenterOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PicCenterOutlinedSvg
  }));
};

PicCenterOutlined.displayName = 'PicCenterOutlined';
export default React.forwardRef(PicCenterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PicCenterOutlined.js
// module id = 3773
// module chunks = 0